module.exports = __webpack_public_path__ + "static/cpes-0f6aa0b73ce4407e09a84213827fe51a.png";